import axios from "axios";

const api = axios.create({
  baseURL: window.location.origin,
  timeout: 8000
});

// Request logger (optional)
api.interceptors.request.use(
  (config) => {
    console.log("➡️ Request:", config.url);
    return config;
  },
  (error) => Promise.reject(error)
);

// Global Response Error Handler
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // Server down / offline / no network
      alert("Server not reachable. Please check WiFi / Router.");
    } else if (error.response.status === 404) {
      alert("Requested resource not found.");
    } else if (error.response.status >= 500) {
      alert("Server error. Please restart backend server.");
    } else {
      alert(error.message || "Unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

export default api;
